import { Badge, Tooltip } from 'antd';
import { WorkspaceMembers } from '@/types/generated/graphql';
import { getDotColor } from '@modules/members/utils/get-dot-color';
import { AppAvatar } from '@components/app-avatar';
import { truncateString } from '@modules/settings/subscription/utils/utils';
import { IconAIIcon } from '@/assets/static/icons';

export function MemberMobileCard(member: WorkspaceMembers) {
  const isActive = member.userOnlineManagement?.isActive;
  const isAIAgent = member?.user?.isAiAgent;
  return (
    <Tooltip
      title={
        <div className="flex items-center">
          <span>
            <AppAvatar
              className="size-9! border-gray-500!"
              shape="circle"
              src={member?.user?.profilePicture?.url}
              name={member?.user?.name}
            />
          </span>
          <div className="leading-5">
            <div className="pl-2">{truncateString(member?.user?.name, 17)}</div>{' '}
            <div className="pl-2 uppercase!">
              {(member?.roles ?? [])
                .filter((role): role is NonNullable<typeof role> => Boolean(role))
                .map((role) => role.label)
                .join(', ')}
            </div>
          </div>
        </div>
      }
      placement="right"
      align={{ offset: [24, 0] }}
    >
      <Badge dot color={getDotColor(isActive)} offset={[-6, 31]}>
        {isAIAgent && (
          <span className="absolute -right-1.5 -top-1.5 z-100">
            <IconAIIcon className="size-2.5 lg:size-3.5 shrink-0!" />
          </span>
        )}
        <AppAvatar
          className="border! border-gray-900!"
          shape="circle"
          size={36}
          src={member?.user?.profilePicture?.url}
          name={member?.user?.name}
        />
      </Badge>
    </Tooltip>
  );
}
